<template>
  <div v-loading="loading && !profiles.length" element-loading-text="Loading Profiles...">
    <div class="infinite-list-wrapper" style="overflow-y:auto; overflow-x:hidden" infinite-scroll-disabled="disabled">
      <el-row :gutter="6" v-infinite-scroll="load" style="height: 600px; overflow:auto">
        <el-col :span="6" v-for="profile in profiles" :key="profile.id">
          <grid-card style="margin: 12px 0px" :profile="profile" @click.native="showProfile(profile)" />
        </el-col>
      </el-row>
    </div>

    <el-row>
      <el-col :span="24" class="text-center">
        <p class="load-more" v-if="loading && profiles.length">
          <i class="el-icon-loading"></i> Loading Profiles...
        </p>

        <p v-if="noMore">All Profiles Loaded</p>
      </el-col>
    </el-row>

    <dialog-card
      :initialProfile="profile"
      :visible="showProfileCard"
      @close="handleCloseCard"
      v-if="profile"
    />
  </div>
</template>

<script>
import { chunk } from 'lodash';
import VirtualList from 'vue-virtual-scroll-list';
import GridCard from '@/components/profiles/profile/GridCard';
import DialogCard from '@/components/profiles/profile/DialogCard';

const GRID_SIZE = 4;

export default {
  name: 'ProfilesBrowser',
  data: () => ({
    gridView: true,
    showProfileCard: false,
    profile: null,
  }),
  components: {
    VirtualList,
    GridCard,
    DialogCard,
  },
  computed: {
    rows() {
      return chunk(this.profiles, GRID_SIZE);
    },
    noMore() {
      return this.profiles.length >= this.filteredTotal;
    },
    disabled() {
      return this.loadingMore || this.noMore;
    },
  },
  methods: {
    load() {
      this.$emit('load-more-profiles');
    },
    handleCloseCard() {
      this.showProfileCard = false;
      this.profile = null;
    },
    showProfile(profile) {
      this.profile = profile;
      this.showProfileCard = true;
    },
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    virtualListSize: {
      type: Number,
      default: 25,
    },
    virtualListRemain: {
      type: Number,
      default: 18,
    },
    profiles: {
      type: Array,
      required: true,
    },
    filteredTotal: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style scoped>
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.load-more {
  font-size: 1.5em;
  padding: 30px 0px;
}
</style>



// WEBPACK FOOTER //
// ProfilesBrowser.vue?bea84524